<template>
  <VueFinalModal
    name="thank-you"
    v-model="showModal"
    :clickToClose="false"
    :content-style="{ maxHeight: '100vh', overflowY: 'auto' }"
    width="100%"
    height="100%"
  >
    <div
      v-bind:class="mode == 'customer' ? 'embthank' : 'embthank-sales'"
      v-bind:style="{ top: `${topPosition}px` }"
    >
      <div class="emb-card">
        <div class="emb-card_body">
          <h3>{{ h3Message }}</h3>
          <p v-if="printOptionSelected">{{ printOptionMessage }}</p>
          <p v-else>{{ dreesMessage }}</p>
          <button
            class="btn"
            @click="handleClose"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </VueFinalModal>
</template>

<script lang="ts" setup>
import { ref, toRefs } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import { ModalType } from '../../constant';
const props = defineProps<{
  topPosition: number;
  printOptionSelected: boolean;
  showModal: boolean;
  mode: string;
}>();

const { topPosition, printOptionSelected, showModal, mode } = toRefs(props);
console.log(mode.value);

const emits = defineEmits(['closeModal']);

const h3Message = ref('Thank you!');
const printOptionMessage = ref('Your printable map is being opened in a new window.');
const dreesMessage = ref('Your request will be reviewed first by our New Home Specialist. They will be in contact shortly to let you know the status of your request. We appreciate your patience.');

const handleClose = () => {
  emits('closeModal', ModalType.THANK_YOU);
};
</script>

<style lang="scss" scoped>
.embthank {
  position: absolute !important;
  top: 148px;
  right: 76px;
  z-index: 1006;
  max-width: 453px !important;

  @include mobile-standard {
    left: 0;
    right: 0;
    max-width: calc(100% - 30px) !important;
    margin: 0 auto;
  }

  .emb-card {
    background: $white;
    box-shadow: 2px 2px 20px $gray;
    padding: 15px 30px 22px 18px;
  }

  h3 {
    font-weight: 600;
    font-size: 21px;
    line-height: 18px;
    color: $light-green;
    margin-bottom: 18px;
  }

  p {
    margin-bottom: 20px;
  }

  .btn {
    font-size: 15px;
    line-height: 20px;
    margin: 0 auto;
  }
}

.embthank-sales {
  position: absolute !important;
  top: 50% !important;
  right: auto;
  z-index: 1006;
  max-width: 453px !important;
  left: calc(50% + 190px);
  transform: translate(-50%, -50%);

  @include mobile-standard {
    left: 50%;
    max-width: calc(100% - 30px) !important;
    width: 100%;
    margin: 0 auto;
  }

  .emb-card {
    background: $white;
    box-shadow: 2px 2px 20px $gray;
    padding: 15px 30px 22px 18px;
  }

  h3 {
    font-weight: 600;
    font-size: 21px;
    line-height: 18px;
    color: $light-green;
    margin-bottom: 18px;
  }

  p {
    margin-bottom: 20px;
  }

  .btn {
    font-size: 15px;
    line-height: 20px;
    margin: 0 auto;
  }
}
</style>
